<template>
  <vContainer fill-height>
    <v-row no-gutters justify="center" class="pt-8">
      <v-col cols="12" align="center">
        <span class="title ">Here's what we've got about you.</span>

      </v-col>
    </v-row>

    <v-row no-gutters :key="index" v-if="userProfile" justify="center">

      <v-col cols="12" md="6">
        <v-form v-model="valid" ref="form">
          <v-row no-gutters justify="center">
            <v-col cols="12" :class="$vuetify.breakpoint.height<700?'':'pb-10'">
              <v-list-item @click="dialog = true">
                <v-row justify="center">
                  <v-list-item-avatar size="120">
                    <v-img :src="((userProfile || {}).public || {}).photoURL" alt="">
                      <v-layout fill-height row justify-center align-center>
                        <v-icon size="30" color="grey lighten-3">add_a_photo</v-icon>
                      </v-layout>
                    </v-img>
                  </v-list-item-avatar>
                  <v-progress-linear v-if="uploading" :value="progressUpload"></v-progress-linear>
                </v-row>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="firstName" :label="$language.registration['First Name']" :rules="nameRule" hide-details required  @blur="$nextTick(() => {$refs.a.focus()})" @keydown.enter="$nextTick(() => {$refs.a.focus()})">
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">person</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>

            </v-col>
            <v-col cols="12">

              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field ref="a" outlined dense v-model="lastName" :label="$language.registration['Last Name']" :rules="nameRule" hide-details required>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">person</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).email" :rules="emailRules" :label="$language.registration['E-mail']" required readonly hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">email</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" v-show="!hide">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).companyName" :label="$language.registration['Company Name (optional)']" hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">business</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="mobilePhone" type="number" mask="phone" :rules="phoneRules" :label="$language.registration['Mobile Phone']" required>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">phone</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" v-show="!hide">
              <v-list-item dense>
                <v-list-item-content>
                  <div :class="` custom-input v-input v-input--is-label-active v-input--is-dirty v-input--dense ${$vuetify.theme.dark?'theme--dark':'theme--light'} v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined`">
                    <div class="v-input__control" style="height:40px">
                      <div :class="`v-input__slot `">
                        <div class="v-input__prepend-inner">
                          <v-icon color="primary">map</v-icon>
                        </div>
                        <gmap-autocomplete ref="search" :class="`v-text-field__slot pt-4 pl-2`" :label="$language.addJob['Job Address']" :placeholder="$language.addJob['Address']" @place_changed="getAddressData">
                        </gmap-autocomplete>
                        <v-btn text icon color="primary lighten-1" class="mx-0 pr-0 mt-0 pt-1" @click="clear">
                          <v-icon medium class="pr-0">cancel</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-text-field outlined light :placeholder="$language.registration['Invite Code']" v-model="referralId"></v-text-field>
          </div>
        </v-form>
      </v-col>
    </v-row>

    <v-row no-gutters justify="center">
      <v-col cols="12" md="8" justify="center">
        <v-btn light :disabled="!valid" block style="height: 60px;" color="primary" class="px-0 ma-0" @click="()=>{updateProfile();$vuetify.goTo(0)}">
          {{ $language.registration["Next"] }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent :max-width="$vuetify.breakpoint.smAndDown ? 270 : 330">
      <v-card>
        <v-row>
          <v-col cols="12" justify="center" align="center">
            <croppa :key="myKey" ref="myCroppa" :width="$vuetify.breakpoint.smAndDown ? 250  : 300" :height="$vuetify.breakpoint.smAndDown ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
            </croppa>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(-1)">
              <v-icon large>rotate_left</v-icon>
            </v-btn>
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(1)">
              <v-icon large>rotate_right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" class="px-2">
            <v-col cols="5">
              <v-btn color="primary" block large text @click.native="dialog = false">Cancel</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn @click="upload" color="primary" block large>Upload</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </vContainer>

</template>

<script>
import { mapState } from 'vuex'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: {
    referralId: String,
    hide: Boolean
  },
  data () {
    return {
      valid: false,
      mobilePhone: '',
      firstName: null,
      lastName: null,
      nameRule: [
        (v) => !!v || 'Name is required'
      ],
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        (v) => !!v || 'Phone number is required',
        (v) => v.length === 10 || 'Must be a valid US phone number.'
      ],
      index: 0,
      dialog: false,
      initial: true,
      uploadReady: false,
      uploading: false,
      uploadEnd: false,
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      downloadURL: '', // What is this for?
      myKey: 0
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])
  },
  mounted () {
    if (Object.keys(this.userProfile).length > 0 && this.currentUser) {
      // console.log(Object.keys(this.userProfile).length, 'here')
      var firstName = this.currentUser.displayName.split(' ')[0]
      var lastName = this.currentUser.displayName.split(' ')[1]
      this.userProfile.public.firstName = firstName || ''
      this.userProfile.public.lastName = lastName || ''
      this.firstName = this.userProfile.public.firstName
      this.lastName = this.userProfile.public.lastName
    }
    this.$nextTick(() => {
      this.mobilePhone =
      ((this.userProfile || {}).public || {}).mobilePhone || ''
      if ((this.userProfile || {}).address) {
        this.$refs.search.$el.value = this.userProfile.address.formatted_address
      }
    })
  },
  methods: {

    updateProfile () {
      let tempCategories = []
      this.categories.forEach(category => {
        tempCategories.push(category._key)
      })
      this.userProfile.public.categories = tempCategories
      if (this.referralId !== undefined) {
        this.userProfile.referralId = this.referralId
      }
      this.userProfile.public.firstName = this.firstName
      this.userProfile.public.lastName = this.lastName
      this.userProfile.public.name =
        this.userProfile.public.firstName +
        ' ' +
        this.userProfile.public.lastName
      this.userProfile.public.mobilePhone = this.mobilePhone
      fb.database
        .ref(`user/${this.currentUser.uid}/profile`)
        .set(this.userProfile)
      this.$emit('next')
    },
    clear () {
      this.userProfile.location = []
      this.userProfile.address = {}
      this.$refs.search.$el.value = null
    },
    getAddressData: function (addressData) {
      var components = {}
      addressData.address_components.map((k) => {
        components[k.types[0]] = k.short_name
      })
      this.userProfile.address = {}
      this.userProfile.address.address1 =
        `${components.street_number} ${components.route}` || ''
      this.userProfile.address.city = components.locality || ''
      this.userProfile.address.state =
        components.administrative_area_level_1 || ''
      this.userProfile.address.zip = components.postal_code || ''
      this.userProfile.address.html = addressData.adr_address || ''
      this.formatted_address = addressData.formatted_address || ''
      this.userProfile.address.formatted_address =
        addressData.formatted_address || ''
      this.userProfile.location.coords = [
        addressData.geometry.location.lat() || 0,
        addressData.geometry.location.lng() || 0
      ]
      fb.database
        .ref(`user/${this.currentUser.uid}/profile`)
        .set(this.userProfile)
    },
    detectFiles () {
      this.uploadReady = true
    },
    rotatePhoto (dir) {
      this.$refs.myCroppa.rotate(dir)
    },
    upload () {
      this.dialog = false
      this.$refs.myCroppa.generateBlob(
        (blob) => {
          this.fileName = blob.name
          this.uploading = true
          this.uploadTask = fb.storage.ref(`images/${this.currentUser.uid}/profile_photo`).put(blob)
        },
        'image/jpeg'
      )
    },

    async removeImage () {
      this.myKey += 1
      this.$refs.myCroppa.remove()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/photoURL`] = ''
      await fb.database.ref().update(updates)
      this.uploadEnd = false
      this.uploading = false
      this.uploadReady = false
      this.initial = true
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploadEnd = true
          this.uploading = false
          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/public/photoURL`] = downloadURL
          fb.database.ref().update(updates)
          // this.downloadURL = downloadURL
          // this.userProfile.photoURL = downloadURL
          // this.$emit('downloadURL', downloadURL) // What is this emit doing here?
        })
      })
    }
  }
}
</script>

<style>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #bdbdbd !important;
  border-radius: 0px;
  padding-left: 10px !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
  border: 2px solid #bdbdbd !important;
}
.custom-input {
  border: 0.5px solid;
  border-color: grey;
}
</style>
